import { ordinalize } from "@/utilities/ordinalize";
import { defineComponent, computed } from "@vue/composition-api";
import { itemRouteBuilder, NamedRts } from "@/router";

export default defineComponent({
  name: "workOrderDetails",

  setup(_props, ctx) {
    let $store = ctx.root.$store;

    const workOrder = computed(() => {
      return $store.getters.workOrder;
    });

    let isFieldWorker = computed(() => {
      return $store.getters.isFieldWorker;
    });

    const clientShowRouteBuilder = (id: string) => {
      return itemRouteBuilder(NamedRts.clientShow, id);
    };

    return {
      workOrder,
      isFieldWorker,

      ordinalize,
      clientShowRouteBuilder,
    };
  },
});
